import { Espace } from './espace.model';

export class Planning {
    idplanning: string;
    datedebut: Date;
    datefin: Date;
    espace: Espace;
    idutilisateur: number;
	idcours: number;
    idclients: any[];

}



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/model/planning.model.ts